import React from "react";
import { Loader2, Sparkles, MessageSquare, Zap, Image as ImageIcon, Users } from "lucide-react";
import { OFFICERS, OfficerBadge } from "../AIOfficers";

export const OfficerPickerView = ({
  fullAccount, skills, toolForSkills, runningSkill,
  onRunSkill, onRunCouncil, onSelectOfficer,
}) => (
  <div className="p-3 overflow-y-auto custom-scroll flex-1">
    {/* Tool-specific senior skills (only for full accounts) */}
    {fullAccount && (
      <div className="mb-4">
        <button
          onClick={onRunCouncil}
          disabled={runningSkill === "council"}
          className="w-full flex items-center gap-2.5 p-3 mb-2 rounded-xl bg-gradient-to-br from-pink-500/[0.08] to-purple-500/[0.06] border border-pink-500/25 hover:border-pink-500/45 transition-all text-left group disabled:opacity-50"
          data-testid="floating-dock-council-mode"
        >
          {runningSkill === "council" ? <Loader2 className="w-4 h-4 animate-spin text-pink-300 flex-shrink-0" /> : <Users className="w-4 h-4 text-pink-300 flex-shrink-0" />}
          <div className="flex-1 min-w-0">
            <p className="text-[11px] font-semibold text-white leading-tight">Council Mode</p>
            <p className="text-[10px] text-gray-500 mt-0.5 leading-snug">3 officers debaten + sintesis ejecutiva</p>
          </div>
          <span className="text-[9px] uppercase tracking-widest text-pink-300 font-bold">NEW</span>
        </button>
      </div>
    )}
    {fullAccount && skills.length > 0 && (
      <div className="mb-4">
        <p className="text-[10px] uppercase tracking-widest text-purple-400 font-medium px-1 mb-2 flex items-center gap-1.5">
          <Zap className="w-3 h-3" />
          Habilidades Senior · {toolForSkills}
        </p>
        <div className="grid grid-cols-1 gap-1.5">
          {skills.map((s) => (
            <button
              key={s.id}
              onClick={() => onRunSkill(s)}
              disabled={runningSkill === s.id}
              className="flex items-start gap-2.5 p-2.5 rounded-xl bg-purple-500/[0.04] border border-purple-500/15 hover:bg-purple-500/[0.08] hover:border-purple-500/30 transition-all text-left group disabled:opacity-50"
              data-testid={`skill-${s.id}`}
            >
              {(s.output_type === "image" || s.output_type === "image_with_text") ? (
                <ImageIcon className="w-3.5 h-3.5 text-pink-300 mt-0.5 flex-shrink-0" />
              ) : (
                <Zap className="w-3.5 h-3.5 text-purple-300 mt-0.5 flex-shrink-0" />
              )}
              <div className="flex-1 min-w-0">
                <p className="text-[11px] font-semibold text-white leading-tight">{s.label}</p>
                <p className="text-[10px] text-gray-500 mt-0.5 leading-snug line-clamp-2">{s.description}</p>
              </div>
              {runningSkill === s.id && <Loader2 className="w-3.5 h-3.5 animate-spin text-purple-400 flex-shrink-0" />}
            </button>
          ))}
        </div>
      </div>
    )}

    <p className="text-[10px] uppercase tracking-widest text-purple-400 font-medium px-1 mb-2 flex items-center gap-1.5">
      <Sparkles className="w-3 h-3" />
      Officers · Conversar
    </p>
    <p className="text-[11px] text-gray-500 px-1 mb-2 leading-snug">
      {fullAccount
        ? "Tu pregunta se respondera con el contexto de la herramienta actual."
        : "Modo demo. Selecciona un officer para ver una vista previa."}
    </p>
    <div className="grid grid-cols-1 gap-1.5">
      {OFFICERS.map((o) => (
        <button
          key={o.id}
          onClick={() => onSelectOfficer(o.id)}
          className="flex items-start gap-3 p-3 rounded-xl bg-white/[0.02] border border-white/[0.05] hover:bg-white/[0.04] hover:border-purple-500/30 transition-all text-left group"
          data-testid={`floating-dock-officer-${o.id}`}
        >
          <OfficerBadge officer={o} size="sm" />
          <div className="flex-1 min-w-0">
            <p className="text-xs font-semibold text-white leading-tight">{o.name}</p>
            <p className="text-[10px] text-gray-500 mt-0.5 leading-snug line-clamp-2">{o.specialty}</p>
          </div>
          <MessageSquare className="w-3.5 h-3.5 text-gray-600 group-hover:text-purple-400 transition-colors mt-1 flex-shrink-0" />
        </button>
      ))}
    </div>
  </div>
);
